@if (hasUnselectedApplicationGroups$ | async) {
  <agr-page-toolbar [pageTitle]="'app.contactperson.navigation.authorizations' | translate">
    <ng-container actions>
      <agr-primary-action
        actionIcon="add"
        [actionText]="'add' | translate"
        (click)="openApplicationGroupDialog()"
        data-test="contactperson-authorizations__appgroup-dialog__open"
      ></agr-primary-action>
    </ng-container>
  </agr-page-toolbar>
}

@for (group of selectedApplicationGroups$ | async; track group) {
  <section data-test="contactperson-authorizations__authorizations" class="spacing--padding-all">
    <div class="button-title">
      <h2 class="text--h6">{{ group.displayName }}</h2>
      <button
        (click)="deleteGroupUseraccess(group.id)"
        mat-stroked-button
        data-test="contactperson-authorizations__delete-group"
      >
        <mat-icon aria-label="Remove">delete</mat-icon>{{ 'remove' | translate }}
      </button>
    </div>
    <mat-table [dataSource]="getApplications(group.id)">
      <ng-container matColumnDef="name">
        <mat-cell *matCellDef="let application" class="flex__child-1">
          <div>{{ application.displayName }}</div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="set">
        <mat-cell *matCellDef="let application" class="mat-input-cell flex__child-3">
          <mat-form-field class="full-width-field">
            <mat-select
              placeholder="Rol"
              [ngModel]="getSelectedRole(application.key) | async"
              (ngModelChange)="setUseraccess(application.key, $event)"
              data-test="contactperson-authorizations__select-role"
            >
              @for (role of roles$ | async; track role) {
                <mat-option [value]="role.key">
                  {{ role.displayName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-cell>
      </ng-container>
      <mat-row *matRowDef="let row; columns: ['name', 'set']"></mat-row>
    </mat-table>
  </section>
}
